<template>
  <div class="column content-box">
    <woot-modal-header
      :header-title="headerTitle"
      :header-content="$t('DOCUMENT_SOURCES.ACTIONS.UPLOAD_DOCUMENT.DESC')"
    />
    <form class="row" @submit.prevent="submitUploadDocument">
      <div class="medium-12">
        <InvalidType v-if="step === UPLOAD_DOCUMENT_STEP.invalid" :file="file" :url="url" />
        <DragFile
          v-if="step === UPLOAD_DOCUMENT_STEP.dragfile"
          :file="file"
          :url="url"
          :url-file-name="urlFileName"
          :is-retrieving-url="isRetrievingUrl"
          :in-valid-url="inValidUrl"
          @url-change="onUrlChange"
          @file-change="onFileChange"
        />
        <Preview
          v-if="step === UPLOAD_DOCUMENT_STEP.preview"
          :file="file"
          :url="url"
          @on-edit-file-name="onEditFileName"
        />
      </div>
      <div class="modal-footer">
        <div class="medium-12 columns">
          <woot-button
            v-if="step === UPLOAD_DOCUMENT_STEP.dragfile && !inValidUrl"
            :is-disabled="!(file || (url && isValid))"
            @click.prevent="nextStep"
          >
            {{ $t('DOCUMENT_SOURCES.ACTIONS.UPLOAD_DOCUMENT.NEXT') }}
          </woot-button>
          <woot-button
            v-if="step === UPLOAD_DOCUMENT_STEP.invalid || inValidUrl"
            @click.prevent="resetData"
          >
            {{ $t('DOCUMENT_SOURCES.ACTIONS.UPLOAD_DOCUMENT.RESUBMIT') }}
          </woot-button>
          <woot-button
            v-if="step === UPLOAD_DOCUMENT_STEP.preview"
            :is-loading="uiFlags.isCreating || uiFlags.isUpdating"
          >
            {{ $t('DOCUMENT_SOURCES.ACTIONS.UPLOAD_DOCUMENT.SUBMIT') }}
          </woot-button>
          <woot-button class="button clear" @click.prevent="onClose">
            {{ $t('DOCUMENT_SOURCES.ACTIONS.UPLOAD_DOCUMENT.CANCEL') }}
          </woot-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import DragFile from './DragFile.vue';
import { checkValidFileType } from 'helpers/FileHelper';
import InvalidType from './InvalidType.vue';
import Preview from './Preview.vue';
import { isValidURL, lastSegmentOfUrl } from '../../../../../helper/URLHelper';
import { UPLOAD_DOCUMENT_STEP } from '../../constants';

export default {
  components: {
    DragFile,
    InvalidType,
    Preview,
  },
  mixins: [alertMixin],
  props: {
    currentDocument: {
      type: Object,
      default: () => {},
    },
    headerTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      file: null,
      url: '',
      displayName: '',
      step: UPLOAD_DOCUMENT_STEP.dragfile,
      urlFileName: '',
      inValidUrl: false,
      isRetrievingUrl: undefined,
      UPLOAD_DOCUMENT_STEP: UPLOAD_DOCUMENT_STEP
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'documents/getUIFlags',
    }),
    isValid() {
      if (this.url) {
        return isValidURL(this.url);
      }
      if (!this.file) {
        return false;
      }
      return checkValidFileType(this.file);
    },
  },
  mounted() {
    if (this.currentDocument && this.currentDocument.id) {
      this.file = this.currentDocument;
    }
  },
  methods: {
    onClose() {
      this.resetData();
      this.$emit('close');
    },
    resetData() {
      this.file = null;
      this.url = '';
      this.step = UPLOAD_DOCUMENT_STEP.dragfile;
      this.isRetrievingUrl = undefined;
      this.urlFileName = '';
      this.inValidUrl = false;
    },
    async submitUploadDocument() {
      try {
        const documentObject = {
          file: this.file,
          url: this.url,
          isFormData: true,
          display_name: this.displayName,
        };
        if (this.file && this.file.id) {
          await this.$store.dispatch('documents/update', {id: this.file.id, display_name: this.displayName});
          this.showAlert(
            this.$t('DOCUMENT_SOURCES.ACTIONS.EDIT.API.SUCCESS_MESSAGE')
          );
        } else {
          let message = this.$t('DOCUMENT_SOURCES.ACTIONS.UPLOAD_DOCUMENT.API.SUCCESS_MESSAGE');
          await this.$store.dispatch('documents/create', documentObject);
          if(this.currentDocument?.id && !this.file?.id) {
            await this.$store.dispatch('documents/delete', this.currentDocument);
            message = this.$t('DOCUMENT_SOURCES.ACTIONS.EDIT.API.SUCCESS_MESSAGE');
          }
          this.showAlert(message);
        }
        this.onClose();
      } catch (error) {
        let errorMessage = this.$t('DOCUMENT_SOURCES.ACTIONS.UPLOAD_DOCUMENT.API.UPLOAD_FAILED');
        if (error?.error?.detail) {
          errorMessage = error.error.detail;
        }
        if (this.file.id) {
          errorMessage = this.$t('DOCUMENT_SOURCES.ACTIONS.EDIT.API.ERROR_MESSAGE');
        }
        this.showAlert(errorMessage);
      }
    },
    onFileChange(file) {
      this.file = file;
    },
    onUrlChange(url) {
      this.url = url;
    },
    onEditFileName(name) {
      this.displayName = name;
    },
    nextStep() {
      if (this.url && !this.urlFileName) {
        this.isRetrievingUrl = true;
        if (isValidURL(this.url)) {
          this.urlFileName = this.url;
          this.isRetrievingUrl = false;
        } else {
          this.inValidUrl = true;
        }
      }
      if ((this.file && this.isValid) || this.urlFileName) {
        this.step = UPLOAD_DOCUMENT_STEP.preview;
      } else if (this.file) {
        this.step = UPLOAD_DOCUMENT_STEP.invalid;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.modal-footer {
  .button {
    margin-right: var(--space-small);
    margin-left: 0;
  }
}
</style>
